import _ from 'lodash';
import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getFunctionSensorIds = createCachedSelector(
  [getPredictor],
  predictor => _.chain(predictor).get('functionMappings').map('sensor').value()
)(
  (state, chartType) => chartType
);